<template>
  <div class="basic-block block-uranaitv-desc-base" :style="styles">
    <div class="sec-mess">
      <img :src="targetInfo.uTvDesc.leadImg" alt="" class="sec-mess__lead-img">
      <p v-html="targetInfo.uTvDesc.lead" class="sec-mess__lead"></p>
      <div class="sec-subscr-previews">
        <template v-for="(item, idx) of previewResultList">
          <subscr-fortune-preview
            :item-index="idx"
            :result-data="item"
            :color-data="previewColors"
            :key="idx"
            :lp-id="lpId"
            class="preview-item"
          />
        </template>
      </div>
      <slot></slot>
      <block-banner2
        class="block-banner--middle"
        :lp-id="lpId"
        banner-pos="middle"
        :campaign="bannerType"
        :target-info="targetInfo"
        :color-scheme="colorScheme"
        :has-caption="false"
        :subsc-url="subscUrl"
        page="basicresult"
      />
    </div>
      <div
        class="subscr-desc"
        v-for="(item, i) in targetInfo.uTvDesc.points"
        :key="i"
      >
      <section :class="`sec sec-${i}`">
        <img v-if="item.preCopy" :class="`desc-pre-copy desc-pre-copy-${i}`" :src="item.preCopy" alt="">
        <div v-if="item.img === '__ex__'" :class="`extend-${i}`" v-html="item.extend"></div>
        <img v-else :class="`desc-img desc-img-${i}`" :src="item.img" alt="">
        <img :class="`desc-copy desc-copy-${i}`" :src="item.copy" alt="">
        <div :class="`btn-wrap btn-wrap-${i}`">
          <lp-base-button
            :label="buttonFace"
            design="fill"
            :color-scheme="colorScheme"
            class="block-uranaitv-base__point-btn"
            @clicked="onSubscrBtnClick(i+1)"
          />
          </div>
        </section>
    </div>
  </div>
</template>

<script>
import SubscrFortunePreview from '@/utvStore/components/recommend/lp/partials/SubscrFortunePreview'
import LpBaseButton from '@/utvStore/components/recommend/lp/partials/LpBaseButton'
import BlockMenus from './BlockMenus'
import BlockBanner2 from '@/utvStore/components/recommend/lp/blocks/BlockBanner2'









export default {
  name: 'BlockUranaiTvDesc',
  components: {
    SubscrFortunePreview,
    LpBaseButton,
    BlockBanner2,
    BlockMenus
  },
  props: {
    lpId: {
      type: Number,
      default: 1,
    },
    bannerType: {
      type: String,
      default: 'LINE',
    },
    targetInfo: {
      type: Object,
      default(){
        return {}
      }
    },
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
    previewResultList: {
      type: Array,
      default: null,
    },
    subscUrl: String,
  },
  computed:{
    styles(){
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
      }
    },
    previewColors(){
      return {
        gradStart: this.colorScheme.gradStart,
        gradEnd: this.colorScheme.gradEnd,
        previewBg: this.colorScheme.messBg,
        previewBorder: 'black',
        font: '#32373f',
        head: this.colorScheme.keyColor,
      }
    },
    buttonFace(){
      return '登録してみる'
    }
  },
  methods: {
    onSubscrBtnClick(val){
      const param = {
        'event_category': `LP${this.lpId}basicresult-subsc-button`,
        'event_label': `0401-${val}`
      }
      window.gtag('event', 'click', param)
      // console.log('param:', param)
      location.href = this.$handoverParams(this.subscUrl)
    },
  }
}
</script>

<style scoped lang="scss">
@import "../../../../../../../../sass/commons/commonVariables.scss";

$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);

.block-uranaitv-desc-base {
  background: #fff;
}
.sec-mess {
  padding: 40px 20px 60px;
  &__lead-img {
    max-width: 100%;
    display: block;
    width: 180px;
    margin: 0 auto 20px;
  }
  &__lead {
    font-size: 16px;
    line-height: 28px;
    color: $l_col_keycolor;
    margin: 0 0 24px;
  }
}
.sec-subscr-previews {
  padding: 0;
  margin: 0 0 60px;
  .preview-item {
    margin-bottom: 16px;
    &:last-of-type {
      margin-bottom: 0;
    }
  }
}
.subscr-desc {
  background: #FFFBE3;
  padding: 0 0 60px;
  .sec {
    text-align: center;
  }
  .desc-img {
    width: 100%;
    max-width: 440px;
    margin: 0 0 60px;
    &-0 { margin-bottom: 24px; }
    &-5 { margin-bottom: 16px; }
  }
  .desc-pre-copy {
    max-width: 100%;
    &-5 { width: 259px; margin-bottom: 16px; }
  }
  .desc-copy {
    max-width: 100%;
    &-0 { width: 241px; }
    &-1 { width: 270px; }
    &-2 { width: 270px; }
    &-3 { width: 270px; }
    &-4 { width: 312px; }
    &-5 { width: 312px; }
  }
  /deep/ .extend {
    max-width: 100%;
    &-5 {
      img {
        width: 64%;
        margin-bottom: 40px;
        @include mq ('w580') {
          width: 50%;
        }
      }
      .seimei {
        position: relative;
        padding-top: 80.4%;
        height: 0;
        background: url(/static/img/seimei/movie.png) no-repeat center center;
        background-size: 100% auto;
        margin-bottom: 40px;
        video {
          position: absolute;
          display: block;
          height: 82%;
          top: 11.5%;
          left: 5%;
          overflow: hidden;
          border-radius: 5px;
          @include mq('w580'){
            height: 84%;
            top: 11.5%;
            left: 5%;
            overflow: hidden;
            border-radius: 5px;
          }
        }
      }
    }
  }
  .btn-wrap {
    width: 72%;
    max-width: 320px;
    padding: 40px 0 70px;
    margin: auto;
    &-0 { padding-bottom: 50px; }
    &-4 { padding-bottom: 20px; }
    &-5 { padding-bottom: 0; }
  }
  .block-uranaitv-base__point-btn {}
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/counselor/kurenotori/blocks/BlockUranaiTvDesc.vue